import { render } from "./Health.vue?vue&type=template&id=5a39ac9a&ts=true"
import script from "./Health.vue?vue&type=script&lang=ts"
export * from "./Health.vue?vue&type=script&lang=ts"

import "./Health.vue?vue&type=style&index=0&id=5a39ac9a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__